/**
 * The last day a booking actually covers. Bryntum stores a day-based end date
 * exclusively — midnight of the day after the booking — while the booking form
 * stores an inclusive end (23:59:59.999), so only a midnight end walks back a
 * day.
 */
export function inclusiveEndDate(endTime: string): Date {
  const end = new Date(endTime);
  const isExclusiveMidnight =
    end.getHours() === 0 && end.getMinutes() === 0
    && end.getSeconds() === 0 && end.getMilliseconds() === 0;
  if (!isExclusiveMidnight) return end;
  const inclusive = new Date(end);
  inclusive.setDate(inclusive.getDate() - 1);
  return inclusive;
}
